import { useContext } from 'react'

import { RequestLicense } from '@components/Submission/Card/Modal/RequestLicense/RequestLicense'
import FacebookAdAccounts from '@components/UI/FacebookAdAccounts'
import { CurrentMediaObjectIdContext } from '@context/CurrentMediaObjectId'
import { useModal } from '@hooks/useModal'

const MediaObjectsFacebookAdAccounts: React.FC = () => {
  const { currentMediaObjectId, setCurrentMediaObjectId } = useContext(CurrentMediaObjectIdContext)
  const { showModal, hideModal } = useModal()

  const onDone = () => {
    if (!currentMediaObjectId) {
      return
    }

    setCurrentMediaObjectId(undefined)
    showModal(RequestLicense, { currentMediaObjectId })
  }

  return (
    <FacebookAdAccounts
      onDone={onDone}
      onMount={hideModal}
      mediaTransferProps={{
        mediaObjectId: currentMediaObjectId as number,
      }}
    />
  )
}

export { MediaObjectsFacebookAdAccounts }
export default MediaObjectsFacebookAdAccounts
